import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LS_KEY = "mae_lang";

const dict = {
    ro: {
        // brand
        brand_tagline: "media · qr · downloader",
        // nav
        nav_gallery: "Galerie",
        nav_downloader: "Descărcări",
        nav_qr: "Cod QR",
        nav_admin: "Admin",
        nav_logout: "Ieșire",
        // login
        login_pre: "db.mae.com.ro · access only",
        login_h1_1: "Spațiu privat.",
        login_h1_2: "O parolă.",
        login_label: "Parolă",
        login_placeholder: "Introduceți parola",
        login_btn: "Intră",
        login_btn_busy: "se verifică…",
        login_wrong: "Parolă incorectă",
        // gallery
        gal_pre: "Galerie",
        gal_h1: "Foto & Video",
        gal_upload: "Încarcă",
        gal_select: "Selectează",
        gal_tab_photos: "Poze",
        gal_tab_videos: "Video",
        gal_empty_photos: "Nicio poză încărcată",
        gal_empty_videos: "Niciun video încărcat",
        gal_empty_btn: "Adaugă primul fișier",
        gal_uploading: "Se încarcă",
        gal_error: "eroare",
        gal_upload_success: "Încărcat",
        gal_upload_fail: "Eșec",
        gal_delete_confirm: "Ștergi",
        gal_deleted: "Șters",
        gal_share: "Partajează",
        gal_download: "Descarcă",
        gal_delete: "Șterge",
        bulk_all: "Toate",
        bulk_deselect: "Deselectează",
        bulk_download_zip: "Descarcă ZIP",
        bulk_zipping: "se arhivează…",
        bulk_delete_confirm: "Ștergi {n} fișier(e)?",
        bulk_deleted: "{n} șters(e)",
        bulk_zip_done: "Arhivă descărcată ({n} fișiere)",
        // downloader
        dl_pre: "Descărcări",
        dl_h1: "YouTube · TikTok · Instagram",
        dl_desc: "Lipește linkul, alege formatul (MP4 video sau MP3 audio) și descarcă direct pe telefon sau laptop.",
        dl_url_label: "Link video",
        dl_url_placeholder: "https://www.youtube.com/watch?v=…",
        dl_preview: "Previzualizare",
        dl_format: "Format",
        dl_mp4_sub: "video + audio · calitate maximă",
        dl_mp3_sub: "doar audio · 192kbps",
        dl_btn: "Descarcă acum",
        dl_btn_busy: "se procesează…",
        dl_save: "Salvează în galerie",
        dl_done: "Descărcare completă",
        dl_saved: "Salvat în galerie",
        dl_footer: "folosește yt-dlp · respectă drepturile de autor",
        dl_detected: "detectat",
        dl_error_fetch: "Nu pot prelua informații",
        dl_error_download: "Eroare la descărcare",
        dl_progress_title: "Descărcare în curs",
        dl_progress_queued: "în coadă",
        dl_progress_downloading: "se descarcă",
        dl_progress_post: "se procesează (merge / convert)",
        dl_progress_done: "gata",
        dl_progress_error: "eroare",
        dl_eta: "ETA",
        dl_speed: "viteză",
        dl_cancel: "Anulează",
        dl_clear: "Închide",
        // qr
        qr_pre: "Cod QR",
        qr_h1: "Generator & arhivă",
        qr_new: "Nou",
        qr_only_admin: "Doar admin poate genera și edita coduri QR.",
        qr_empty_pre: "empty archive",
        qr_empty: "Niciun cod QR salvat încă",
        qr_label: "Etichetă",
        qr_label_placeholder: "ex: WiFi cabană",
        qr_type: "Tip",
        qr_type_text: "Text",
        qr_type_url: "Link",
        qr_type_wifi: "WiFi",
        qr_text: "Text",
        qr_text_placeholder: "Conținutul textului…",
        qr_url: "Link",
        qr_ssid: "Nume rețea (SSID)",
        qr_password: "Parolă",
        qr_security: "Securitate",
        qr_nopass: "Fără parolă",
        qr_hidden: "Rețea ascunsă",
        qr_fg: "Culoare cod",
        qr_bg: "Fundal",
        qr_cancel: "Anulează",
        qr_generate: "Generează",
        qr_regenerate: "Regenerează",
        qr_saving: "se salvează…",
        qr_saved: "Cod generat",
        qr_updated: "Cod actualizat",
        qr_deleted: "Șters",
        qr_delete_confirm: "Ștergi codul",
        qr_modal_pre_new: "nou",
        qr_modal_pre_edit: "editează",
        qr_modal_title: "Cod QR",
        // share
        share_create: "Link temporar",
        share_duration: "Durată",
        share_d_1h: "1 oră",
        share_d_6h: "6 ore",
        share_d_24h: "24 ore",
        share_d_3d: "3 zile",
        share_d_7d: "7 zile",
        share_btn_generate: "Generează link + cod QR",
        share_btn_busy: "se generează…",
        share_btn_more: "Mai creează unul",
        share_btn_download_qr: "Descarcă QR",
        share_copied: "Link copiat",
        share_copy_fail: "Nu pot copia",
        share_revoke_confirm: "Revoci acest link?",
        share_revoked: "Revocat",
        share_created: "Link partajat creat",
        share_expires_in: "expiră în",
        share_active_list: "Linkuri active",
        share_active: "activ",
        share_expired: "expirat",
        // share public
        share_pub_brand: "db.mae · partajat",
        share_pub_h1: "Fișier privat",
        share_pub_denied: "Acces refuzat",
        share_pub_default_err: "Link invalid sau expirat",
        share_pub_dl: "Descarcă",
        share_pub_footer: "db.mae.com.ro · link temporar",
        // admin
        admin_pre: "Admin",
        admin_h1: "Instrumente",
        admin_backup_title: "Backup site",
        admin_backup_desc: "Descarcă o arhivă ZIP cu codul sursă (backend + frontend). Nu include media și node_modules.",
        admin_backup_btn: "Descarcă backup ZIP",
        admin_backup_busy: "se arhivează…",
        admin_update_title: "Update site",
        admin_update_desc: "Încarcă o arhivă ZIP produsă cu backup pentru a aplica noua versiune. Backend-ul se va reporni automat. Fișierele media și parolele rămân intacte.",
        admin_update_pick: "Alege arhiva .zip",
        admin_update_btn: "Aplică update",
        admin_update_busy: "se aplică…",
        admin_update_ok: "Update aplicat — {n} fișiere",
        admin_update_warn: "Atenție: această acțiune înlocuiește codul aplicației.",
        admin_stats_title: "Stare server",
        admin_disk_used: "Folosit",
        admin_disk_free: "Liber",
        admin_disk_total: "Total",
        admin_count_images: "Poze",
        admin_count_videos: "Videoclipuri",
        admin_count_qrs: "Coduri QR",
        admin_max_upload: "Limită upload",
        admin_cookies_title: "Cookies YouTube/Instagram",
        admin_cookies_desc: "YouTube și Instagram blochează frecvent serverele cloud. Exportă cookies.txt din browserul tău (extensia 'Get cookies.txt LOCALLY' pe Chrome/Firefox) și încarcă-l aici pentru a debloca descărcările.",
        admin_cookies_status_yes: "Cookies încărcate",
        admin_cookies_status_no: "Niciun cookie",
        admin_cookies_pick: "Alege cookies.txt",
        admin_cookies_upload: "Încarcă cookies",
        admin_cookies_delete: "Șterge cookies",
        admin_cookies_uploaded: "Cookies salvate",
        admin_cookies_deleted: "Cookies șterse",
        // common
        loading: "se încarcă…",
        unknown_error: "Eroare necunoscută",
        confirm: "Confirmi?",
    },
    en: {
        brand_tagline: "media · qr · downloader",
        nav_gallery: "Gallery",
        nav_downloader: "Downloads",
        nav_qr: "QR Code",
        nav_admin: "Admin",
        nav_logout: "Sign out",
        login_pre: "db.mae.com.ro · access only",
        login_h1_1: "Private space.",
        login_h1_2: "One password.",
        login_label: "Password",
        login_placeholder: "Enter password",
        login_btn: "Enter",
        login_btn_busy: "checking…",
        login_wrong: "Wrong password",
        gal_pre: "Gallery",
        gal_h1: "Photos & Videos",
        gal_upload: "Upload",
        gal_select: "Select",
        gal_tab_photos: "Photos",
        gal_tab_videos: "Videos",
        gal_empty_photos: "No photos uploaded",
        gal_empty_videos: "No videos uploaded",
        gal_empty_btn: "Add the first file",
        gal_uploading: "Uploading",
        gal_error: "error",
        gal_upload_success: "Uploaded",
        gal_upload_fail: "Failed",
        gal_delete_confirm: "Delete",
        gal_deleted: "Deleted",
        gal_share: "Share",
        gal_download: "Download",
        gal_delete: "Delete",
        bulk_all: "All",
        bulk_deselect: "Deselect",
        bulk_download_zip: "Download ZIP",
        bulk_zipping: "archiving…",
        bulk_delete_confirm: "Delete {n} file(s)?",
        bulk_deleted: "{n} deleted",
        bulk_zip_done: "Archive downloaded ({n} files)",
        dl_pre: "Downloads",
        dl_h1: "YouTube · TikTok · Instagram",
        dl_desc: "Paste the link, choose the format (MP4 video or MP3 audio) and download straight to your phone or laptop.",
        dl_url_label: "Video link",
        dl_url_placeholder: "https://www.youtube.com/watch?v=…",
        dl_preview: "Preview",
        dl_format: "Format",
        dl_mp4_sub: "video + audio · max quality",
        dl_mp3_sub: "audio only · 192kbps",
        dl_btn: "Download now",
        dl_btn_busy: "processing…",
        dl_save: "Save to gallery",
        dl_done: "Download complete",
        dl_saved: "Saved to gallery",
        dl_footer: "powered by yt-dlp · respect copyright",
        dl_detected: "detected",
        dl_error_fetch: "Cannot fetch info",
        dl_error_download: "Download error",
        dl_progress_title: "Downloading",
        dl_progress_queued: "queued",
        dl_progress_downloading: "downloading",
        dl_progress_post: "post-processing (merge / convert)",
        dl_progress_done: "done",
        dl_progress_error: "error",
        dl_eta: "ETA",
        dl_speed: "speed",
        dl_cancel: "Cancel",
        dl_clear: "Close",
        qr_pre: "QR Code",
        qr_h1: "Generator & archive",
        qr_new: "New",
        qr_only_admin: "Only admin can create or edit QR codes.",
        qr_empty_pre: "empty archive",
        qr_empty: "No QR codes saved yet",
        qr_label: "Label",
        qr_label_placeholder: "ex: Cabin WiFi",
        qr_type: "Type",
        qr_type_text: "Text",
        qr_type_url: "Link",
        qr_type_wifi: "WiFi",
        qr_text: "Text",
        qr_text_placeholder: "Text content…",
        qr_url: "Link",
        qr_ssid: "Network name (SSID)",
        qr_password: "Password",
        qr_security: "Security",
        qr_nopass: "No password",
        qr_hidden: "Hidden network",
        qr_fg: "Code color",
        qr_bg: "Background",
        qr_cancel: "Cancel",
        qr_generate: "Generate",
        qr_regenerate: "Regenerate",
        qr_saving: "saving…",
        qr_saved: "Code generated",
        qr_updated: "Code updated",
        qr_deleted: "Deleted",
        qr_delete_confirm: "Delete the code",
        qr_modal_pre_new: "new",
        qr_modal_pre_edit: "edit",
        qr_modal_title: "QR Code",
        share_create: "Temporary link",
        share_duration: "Duration",
        share_d_1h: "1 hour",
        share_d_6h: "6 hours",
        share_d_24h: "24 hours",
        share_d_3d: "3 days",
        share_d_7d: "7 days",
        share_btn_generate: "Generate link + QR",
        share_btn_busy: "generating…",
        share_btn_more: "Make another",
        share_btn_download_qr: "Download QR",
        share_copied: "Link copied",
        share_copy_fail: "Cannot copy",
        share_revoke_confirm: "Revoke this link?",
        share_revoked: "Revoked",
        share_created: "Share link created",
        share_expires_in: "expires in",
        share_active_list: "Active links",
        share_active: "active",
        share_expired: "expired",
        share_pub_brand: "db.mae · shared",
        share_pub_h1: "Private file",
        share_pub_denied: "Access denied",
        share_pub_default_err: "Invalid or expired link",
        share_pub_dl: "Download",
        share_pub_footer: "db.mae.com.ro · temporary link",
        admin_pre: "Admin",
        admin_h1: "Tools",
        admin_backup_title: "Site backup",
        admin_backup_desc: "Download a ZIP archive with source code (backend + frontend). Excludes media and node_modules.",
        admin_backup_btn: "Download backup ZIP",
        admin_backup_busy: "archiving…",
        admin_update_title: "Site update",
        admin_update_desc: "Upload a ZIP produced via backup to apply the new version. Backend restarts automatically. Media files and passwords are preserved.",
        admin_update_pick: "Pick .zip archive",
        admin_update_btn: "Apply update",
        admin_update_busy: "applying…",
        admin_update_ok: "Update applied — {n} files",
        admin_update_warn: "Warning: this action replaces the application code.",
        admin_stats_title: "Server status",
        admin_disk_used: "Used",
        admin_disk_free: "Free",
        admin_disk_total: "Total",
        admin_count_images: "Photos",
        admin_count_videos: "Videos",
        admin_count_qrs: "QR codes",
        admin_max_upload: "Upload cap",
        admin_cookies_title: "YouTube/Instagram cookies",
        admin_cookies_desc: "YouTube and Instagram frequently block cloud servers. Export cookies.txt from your browser (Chrome/Firefox extension 'Get cookies.txt LOCALLY') and upload it here to unblock downloads.",
        admin_cookies_status_yes: "Cookies uploaded",
        admin_cookies_status_no: "No cookies",
        admin_cookies_pick: "Pick cookies.txt",
        admin_cookies_upload: "Upload cookies",
        admin_cookies_delete: "Delete cookies",
        admin_cookies_uploaded: "Cookies saved",
        admin_cookies_deleted: "Cookies deleted",
        loading: "loading…",
        unknown_error: "Unknown error",
        confirm: "Are you sure?",
    },
    it: {
        brand_tagline: "media · qr · downloader",
        nav_gallery: "Galleria",
        nav_downloader: "Download",
        nav_qr: "Codice QR",
        nav_admin: "Admin",
        nav_logout: "Esci",
        login_pre: "db.mae.com.ro · accesso riservato",
        login_h1_1: "Spazio privato.",
        login_h1_2: "Una password.",
        login_label: "Password",
        login_placeholder: "Inserisci la password",
        login_btn: "Entra",
        login_btn_busy: "verifica…",
        login_wrong: "Password errata",
        gal_pre: "Galleria",
        gal_h1: "Foto & Video",
        gal_upload: "Carica",
        gal_select: "Seleziona",
        gal_tab_photos: "Foto",
        gal_tab_videos: "Video",
        gal_empty_photos: "Nessuna foto caricata",
        gal_empty_videos: "Nessun video caricato",
        gal_empty_btn: "Aggiungi il primo file",
        gal_uploading: "Caricamento",
        gal_error: "errore",
        gal_upload_success: "Caricato",
        gal_upload_fail: "Fallito",
        gal_delete_confirm: "Eliminare",
        gal_deleted: "Eliminato",
        gal_share: "Condividi",
        gal_download: "Scarica",
        gal_delete: "Elimina",
        bulk_all: "Tutti",
        bulk_deselect: "Deseleziona",
        bulk_download_zip: "Scarica ZIP",
        bulk_zipping: "creazione archivio…",
        bulk_delete_confirm: "Eliminare {n} file?",
        bulk_deleted: "{n} eliminati",
        bulk_zip_done: "Archivio scaricato ({n} file)",
        dl_pre: "Download",
        dl_h1: "YouTube · TikTok · Instagram",
        dl_desc: "Incolla il link, scegli il formato (MP4 video o MP3 audio) e scarica direttamente su telefono o laptop.",
        dl_url_label: "Link video",
        dl_url_placeholder: "https://www.youtube.com/watch?v=…",
        dl_preview: "Anteprima",
        dl_format: "Formato",
        dl_mp4_sub: "video + audio · qualità massima",
        dl_mp3_sub: "solo audio · 192kbps",
        dl_btn: "Scarica ora",
        dl_btn_busy: "elaborazione…",
        dl_save: "Salva in galleria",
        dl_done: "Download completato",
        dl_saved: "Salvato in galleria",
        dl_footer: "powered by yt-dlp · rispetta il copyright",
        dl_detected: "rilevato",
        dl_error_fetch: "Impossibile recuperare le info",
        dl_error_download: "Errore di download",
        dl_progress_title: "Download in corso",
        dl_progress_queued: "in coda",
        dl_progress_downloading: "scaricamento",
        dl_progress_post: "post-elaborazione (merge / converti)",
        dl_progress_done: "fatto",
        dl_progress_error: "errore",
        dl_eta: "ETA",
        dl_speed: "velocità",
        dl_cancel: "Annulla",
        dl_clear: "Chiudi",
        qr_pre: "Codice QR",
        qr_h1: "Generatore & archivio",
        qr_new: "Nuovo",
        qr_only_admin: "Solo l'admin può creare e modificare i codici QR.",
        qr_empty_pre: "archivio vuoto",
        qr_empty: "Nessun codice QR salvato",
        qr_label: "Etichetta",
        qr_label_placeholder: "es: WiFi casa",
        qr_type: "Tipo",
        qr_type_text: "Testo",
        qr_type_url: "Link",
        qr_type_wifi: "WiFi",
        qr_text: "Testo",
        qr_text_placeholder: "Contenuto del testo…",
        qr_url: "Link",
        qr_ssid: "Nome rete (SSID)",
        qr_password: "Password",
        qr_security: "Sicurezza",
        qr_nopass: "Nessuna password",
        qr_hidden: "Rete nascosta",
        qr_fg: "Colore codice",
        qr_bg: "Sfondo",
        qr_cancel: "Annulla",
        qr_generate: "Genera",
        qr_regenerate: "Rigenera",
        qr_saving: "salvataggio…",
        qr_saved: "Codice generato",
        qr_updated: "Codice aggiornato",
        qr_deleted: "Eliminato",
        qr_delete_confirm: "Eliminare il codice",
        qr_modal_pre_new: "nuovo",
        qr_modal_pre_edit: "modifica",
        qr_modal_title: "Codice QR",
        share_create: "Link temporaneo",
        share_duration: "Durata",
        share_d_1h: "1 ora",
        share_d_6h: "6 ore",
        share_d_24h: "24 ore",
        share_d_3d: "3 giorni",
        share_d_7d: "7 giorni",
        share_btn_generate: "Genera link + QR",
        share_btn_busy: "generazione…",
        share_btn_more: "Crea un altro",
        share_btn_download_qr: "Scarica QR",
        share_copied: "Link copiato",
        share_copy_fail: "Impossibile copiare",
        share_revoke_confirm: "Revocare questo link?",
        share_revoked: "Revocato",
        share_created: "Link di condivisione creato",
        share_expires_in: "scade tra",
        share_active_list: "Link attivi",
        share_active: "attivo",
        share_expired: "scaduto",
        share_pub_brand: "db.mae · condiviso",
        share_pub_h1: "File privato",
        share_pub_denied: "Accesso negato",
        share_pub_default_err: "Link non valido o scaduto",
        share_pub_dl: "Scarica",
        share_pub_footer: "db.mae.com.ro · link temporaneo",
        admin_pre: "Admin",
        admin_h1: "Strumenti",
        admin_backup_title: "Backup del sito",
        admin_backup_desc: "Scarica un archivio ZIP con il codice sorgente (backend + frontend). Esclude media e node_modules.",
        admin_backup_btn: "Scarica ZIP backup",
        admin_backup_busy: "archiviazione…",
        admin_update_title: "Aggiorna il sito",
        admin_update_desc: "Carica un ZIP prodotto dal backup per applicare la nuova versione. Il backend si riavvia in automatico. I file media e le password rimangono intatti.",
        admin_update_pick: "Scegli archivio .zip",
        admin_update_btn: "Applica aggiornamento",
        admin_update_busy: "applicazione…",
        admin_update_ok: "Aggiornamento applicato — {n} file",
        admin_update_warn: "Attenzione: questa azione sostituisce il codice dell'applicazione.",
        admin_stats_title: "Stato server",
        admin_disk_used: "Usato",
        admin_disk_free: "Libero",
        admin_disk_total: "Totale",
        admin_count_images: "Foto",
        admin_count_videos: "Video",
        admin_count_qrs: "Codici QR",
        admin_max_upload: "Limite upload",
        admin_cookies_title: "Cookies YouTube/Instagram",
        admin_cookies_desc: "YouTube e Instagram bloccano spesso i server cloud. Esporta cookies.txt dal tuo browser (estensione Chrome/Firefox 'Get cookies.txt LOCALLY') e caricalo qui per sbloccare i download.",
        admin_cookies_status_yes: "Cookies caricati",
        admin_cookies_status_no: "Nessun cookie",
        admin_cookies_pick: "Scegli cookies.txt",
        admin_cookies_upload: "Carica cookies",
        admin_cookies_delete: "Elimina cookies",
        admin_cookies_uploaded: "Cookies salvati",
        admin_cookies_deleted: "Cookies eliminati",
        loading: "caricamento…",
        unknown_error: "Errore sconosciuto",
        confirm: "Sei sicuro?",
    },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try {
            return localStorage.getItem(LS_KEY) || "ro";
        } catch {
            return "ro";
        }
    });

    const setLang = useCallback((l) => {
        if (!dict[l]) return;
        setLangState(l);
        try { localStorage.setItem(LS_KEY, l); } catch {}
        try { document.documentElement.lang = l; } catch {}
    }, []);

    useEffect(() => {
        try { document.documentElement.lang = lang; } catch {}
    }, [lang]);

    const t = useCallback(
        (key, vars) => {
            const raw = (dict[lang] && dict[lang][key]) || dict.ro[key] || key;
            if (!vars) return raw;
            return Object.keys(vars).reduce(
                (s, k) => s.replace(new RegExp(`\\{${k}\\}`, "g"), String(vars[k])),
                raw
            );
        },
        [lang]
    );

    return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useT() {
    const ctx = useContext(LangCtx);
    if (!ctx) {
        return {
            lang: "ro",
            setLang: () => {},
            t: (k, v) => {
                const raw = dict.ro[k] || k;
                if (!v) return raw;
                return Object.keys(v).reduce(
                    (s, kk) => s.replace(new RegExp(`\\{${kk}\\}`, "g"), String(v[kk])),
                    raw
                );
            },
        };
    }
    return ctx;
}
